import { normerNom } from '@/scripts/global.js';

export function getErreurTexteRequis(texte, condition) {
	if (condition === false) {
		return null;
	}
	if (!texte) {
		return 'Un texte doit être renseigné';
	} else {
		return null;
	}
}

export function getErreurValeurListeRequise(texte, condition) {
	if (condition === false) {
		return null;
	}
	if (!texte) {
		return 'Une valeur doit être sélectionnée';
	} else {
		return null;
	}
}

export function getErreurFichierRequis(fichier, condition) {
	if (condition === false) {
		return null;
	}
	if (!fichier) {
		return 'Un fichier doit être sélectionné';
	} else {
		return null;
	}
}

export function getErreurNomNorme(nom, typeNommage, condition) {
	if (condition === false) {
		return null;
	}
	if (!nom) {
		return 'Un nom doit être renseigné';
	} else if (normerNom(nom, typeNommage) !== nom) {
		return typeNommage.description;
	} else {
		return null;
	}
}

